import MostSearchedTerms from './MostSearchedTerms';

export default MostSearchedTerms;
